/** Floating overlay with optional arrow. Wraps React Aria Popover. */
import {
  Popover as AriaPopover,
  OverlayArrow as AriaOverlayArrow,
  type PopoverProps as AriaPopoverProps,
} from 'react-aria-components';
import { cn } from '@/foundation/utils/cn';
import { useInterfacePortalContainer } from '@/foundation/ui/InterfacePortalContext';

interface PopoverProps extends Omit<AriaPopoverProps, 'children'> {
  className?: string;
  showArrow?: boolean;
  children?: React.ReactNode;
}

export function Popover({ className, showArrow = false, children, ...props }: PopoverProps) {
  const portalContainer = useInterfacePortalContainer();

  return (
    <AriaPopover
      UNSTABLE_portalContainer={portalContainer ?? undefined}
      offset={8}
      className={cn(
        'rounded-xl border border-[var(--f-border-strong)] bg-[var(--f-bg-raised)] shadow-lg',
        'data-[entering]:animate-fade-in data-[exiting]:animate-fade-out',
        className
      )}
      {...props}
    >
      {showArrow && (
        <OverlayArrow>
          <svg
            width={12}
            height={12}
            viewBox="0 0 12 12"
            className="fill-[var(--f-bg-raised)] stroke-[var(--f-border-strong)]"
          >
            <path d="M0 0 L6 6 L12 0" />
          </svg>
        </OverlayArrow>
      )}
      {children}
    </AriaPopover>
  );
}

export function OverlayArrow(props: React.ComponentProps<typeof AriaOverlayArrow>) {
  return <AriaOverlayArrow {...props} />;
}
